<header *im2mLet="loggedInUser$ | async as loggedInUser">
    <div class="banner">
        <a class="logo">
            <img src="assets/img/logo.png" alt="Liebherr" class="menu-logo" />
        </a>
    </div>
    <div class="navigation">
        <nav>
            <button mat-button routerLink="/devices" routerLinkActive="active">
                {{ 'MENU.DEVICE_OVERVIEW' | transloco }}
            </button>

            <button *ngIf="loggedInUser | liebherrPermission : [UserRoles.LCO_GET_3]" mat-button routerLink="/firmwares" routerLinkActive="active">
                {{ 'MENU.FIRMWARES' | transloco }}
            </button>

            <button *ngIf="loggedInUser | liebherrPermission : [UserRoles.LCO_GET_2]" mat-button routerLink="/sim-cards" routerLinkActive="active">
                {{ 'MENU.SIM_CARDS' | transloco }}
            </button>

            <button mat-icon-button [matMenuTriggerFor]="menu" class="menu-icon" *im2mLet="loggedInUser$ | async as loggedInUser">
                <mat-icon>person</mat-icon>
                <mat-menu #menu="matMenu" class="headerMenu">
                    <button mat-menu-item (click)="openLanguageDlg(loggedInUser)">
                        {{ 'MENU.LANGUAGE' | transloco }}
                    </button>
                    <button mat-menu-item (click)="onLogout()">
                        {{ 'MENU.LOGGOUT' | transloco }}
                    </button>
                </mat-menu>
            </button>
        </nav>
    </div>
    <div class="subline">
        <button mat-icon-button class="menu-icon">
            <mat-icon class="outlined">account_tree</mat-icon>
        </button>
        <h4 *ngIf="loggedInUserTenantName$ | async as loggedInUserTenantName">/ {{ loggedInUserTenantName }}</h4>
    </div>
</header>

<main>
    <router-outlet></router-outlet>
</main>

<footer></footer>
